// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ViewAllSuggestions-cls1__da1790147d8d5f7b0894{/*!*/}.ViewAllSuggestions-cls2___f80fee3cd3766fedac4{display:flex;align-items:center;justify-content:center;width:40px;height:40px;color:#91919e;background-color:#fff;border:1px solid #dddde2;border-radius:50%;box-shadow:0 2px 4px 0 rgba(0,0,0,.1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ViewAllSuggestions-cls1__da1790147d8d5f7b0894",
	"cls2": "ViewAllSuggestions-cls2___f80fee3cd3766fedac4 ViewAllSuggestions-cls1__da1790147d8d5f7b0894"
};
export default ___CSS_LOADER_EXPORT___;
